import { Pipe, PipeTransform } from '@angular/core';
import { ImageReference } from '@flyfreely-portal-ui/flyfreely';

const BLANK_PIXEL =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

/**
 * Finds the image url from an ImageReference array, otherwise
 * uses a default image.
 */
@Pipe({
    name: 'imageReferenceUrl',
    pure: true
})
export class ImageReferenceUrlPipe implements PipeTransform {
    transform(
        value: ImageReference[] | undefined,
        imageId: string,
        defaultImage?: string
    ): string {
        if (value == null) {
            return defaultImage ?? BLANK_PIXEL;
        }
        return value.find(e => e.id === imageId)?.url ?? defaultImage ?? BLANK_PIXEL;
    }
}
